import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'components/ReflexBox';

import { H1, H3, Text, TextLight } from 'components/Typo';

const Wrapper = styled(Box)`
  ${H1} {
    margin-top: ${(p) => p.theme.spacePx[0]};
    margin-bottom: ${(p) => p.theme.spacePx[2]};
  }

  ${H3} {
    font-weight: 400;
    margin-bottom: ${(p) => p.theme.spacePx[2]};
  }
`;

const Title = styled(TextLight)`
  margin-bottom: 10px;
`;

const Items = styled(Box)`
  div:last-child {
    margin-bottom: 0;
  }

  a {
    display: block;
  }
`;

const ExpandTeam = styled(Text)`
  color: ${(p) => p.theme.colors.textLight};
  cursor: pointer;

  &:hover {
    color: ${(p) => p.theme.colors.text};
  }
`;

const ProjectIntro = ({
  title,
  description = '',
  client = '',
  tasks = [],
  team = [],
  published = '',
  links = [],
}) => {
  const [isTeamExpanded, setTeamExpanded] = useState(false);
  const teamNames = isTeamExpanded ? team : team.slice(0, 4);

  return (
    <Wrapper py={[5, 6, 7, 8]}>
      <Flex pb={5} flexWrap="wrap" alignItems="flex-end">
        <Box width={[1, 1, 1 / 2]} pr={3}>
          <TextLight>{client}</TextLight>
          <H1 style={{ width: '80%' }}>{title}</H1>
        </Box>
        <Box width={[1, 1, 1 / 2]}>
          <H3>{description}</H3>
        </Box>
      </Flex>
      <Flex marginX={-1} flexWrap="wrap">
        <Box width={[1 / 2, 1 / 4]} p={1}>
          <Title>Tasks</Title>
          <Items>
            {tasks.map((t) => (
              <Text key={t}>{t}</Text>
            ))}
          </Items>
        </Box>
        <Box width={[1 / 2, 1 / 4]} p={1}>
          <Title>Team</Title>
          <Items>
            {teamNames.map((t) => (
              <Text key={t}>{t}</Text>
            ))}
            {!isTeamExpanded && team.length > 4 && (
              <ExpandTeam onClick={() => setTeamExpanded(true)}>
                and more...
              </ExpandTeam>
            )}
          </Items>
        </Box>
        <Box width={[1 / 2, 1 / 4]} p={1}>
          <Title>Published</Title>
          <Text>{published}</Text>
        </Box>
        <Box width={[1 / 2, 1 / 4]} p={1}>
          <Title>Links</Title>
          <Items>
            {links.map((link) => (
              <a
                target="_blank"
                rel="noreferrer"
                key={link.text}
                href={link.href}
              >
                {link.text}
              </a>
            ))}
          </Items>
        </Box>
      </Flex>
    </Wrapper>
  );
};

export default ProjectIntro;
